import React from "react";

import styled from "styled-components";

const PageNotificationContentComponent: React.FunctionComponent = () =>
{
    return (
        <>
            <WelcomeText></WelcomeText>
            <SubText>
                There’s an issue affecting Meta Audience Network iOS fill rate on adapter version 5.10.1.6. Please make sure to update MAX SDK and use the latest Meta Audience Network adapter version 5.10.1.7 to avoid the issue.
            </SubText>
        </>
    );
};


const WelcomeText = styled.div`
    
    text-align: center;
    font-family: ${props => props.theme.fonts.black};
    font-size: 20px;
    color: black;
    line-height: 27px;
`;

const SubText = styled.span`
    
    font-family: ${props => props.theme.fonts.roman};
    font-size: 16px;
    text-align: center;
    line-height: 27px;
    color: #20AFD7;
    
    padding: 0 90px;
`;

export default PageNotificationContentComponent;
